export default __webpack_public_path__ + "media/zurb/img/home/home-tool-sketch-c021aa2a670b8bbffca1b83d2c8e658f.png";